import { useLayoutEffect, useRef } from "react";
import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/lib/utils";

export const AutoGrowTextarea = ({ value, className, ...props }) => {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) { return; }
    el.style.height = "auto";
    el.style.height = `${el.scrollHeight + 2}px`;
  }, [value]);
  return (
    <Textarea
      ref={ref}
      rows={2}
      value={value}
      className={cn("min-h-[56px] resize-none overflow-hidden leading-snug py-1.5", className)}
      {...props}
    />
  );
};
